export default __webpack_public_path__ + "static/media/Gloves of the Bloodmoon.8578ef70.jpg";